const ON_USER_INIT = "ON_USER_INIT";
const ON_USER_CLEAN = "ON_USER_CLEAN";

export const rdx_on_user_init  = (newState) => ({ type : ON_USER_INIT, newState })
export const rdx_on_user_clean = (newState) => ({ type : ON_USER_CLEAN, newState })

export const user = (state = {}, action) => {
	switch (action.type) {
    	case ON_USER_INIT :
            console.log(state, action)
	      	return { ...state, user: action.newState }
        case ON_USER_CLEAN :
            console.log('清掉')
            return { ...state }
        default: return state;
  	}
}


// WEBPACK FOOTER //
// ./src/reducers/user.js